/* eslint-disable */
import moment from 'moment';

export const serialize = function (obj) {
  var str = [];
  for (var p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
    }
  return `?${str.join('&')}`;
};

export const isScheduleAvailable = function (day) {
  const now = moment();
  const schedule = moment(day);
  const diffInMinutes = moment(schedule).diff(now, 'minutes');
  return !(Math.abs(diffInMinutes) <= 15);
};

export function isTokenExpired(token) {
  if (!token || typeof token !== 'string') {
    return { expired: true, valid: false };
  }
  const parts = token.trim().split('.');
  if (parts.length !== 3) {
    return { expired: true, valid: false };
  }
  try {
    const payload = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const decoded = JSON.parse(atob(payload));
    if (typeof decoded.exp !== 'number') {
      return { expired: true, valid: false };
    }
    const now = Math.floor(Date.now() / 1000);
    return {
      expired: decoded.exp < now,
      valid: true,
    };
  } catch {
    return { expired: true, valid: false };
  }
}

/**
 * Returns integer age in years from a birthdate, or null if invalid.
 * Accepts YYYY-MM-DD, DD/MM/YYYY, or ISO strings.
 */
export function isTissError(source) {
  if (!source || typeof source !== 'object') return false;
  if (source.tissError === true) return true;
  if (source.data?.tissError === true) return true;
  if (source.response?.data?.tissError === true) return true;
  if (source.message?.tissError === true) return true;
  if (source.message?.data?.tissError === true) return true;
  return false;
}

export function getAgeFromBirthdate(birthdate) {
  if (!birthdate) return null;
  const birth = moment(birthdate, ['YYYY-MM-DD', 'DD/MM/YYYY', moment.ISO_8601], true);
  if (!birth.isValid()) return null;
  const age = moment().diff(birth, 'years');
  if (!Number.isInteger(age) || age < 0 || age > 120) return null;
  return age;
}
